import React from "react";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";
import { formatMoney } from "../config/siteConfig";

function Shop() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="shop main">
      <section className="new-arrivals">
        <div className="container">
          <div className="section-header">
            <h2>Sale</h2>
          </div>
          <div className="product-grid">
            {productData.map((product) => (
              <Link
                to={`/shopDetails/${product.id}`}
                onClick={toTop}
                key={product.id}
                className="product-card"
              >
                <div className="product-image">
                  <span className="tag-new">NEW</span>
                  <img src={product.image} alt={product.name} loading="lazy" />
                </div>
                <div className="product-info">
                  <h3>{product.name}</h3>
                  <p className="price">{formatMoney(product.price)}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Shop;
